import { allChildNodes, isElement } from 'func-xml';
import {
    paramDsName,
    paramJson,
    paramXPath,
} from '../constants/parameterNames';
import { typeDataSource, typeXPath } from '../constants/parameterTypes';
import { getParamValue } from '../helpers/parameter.accessors';
import { getDataSource } from '../helpers/qRules.dataSource.helpers';
import { getValidNode } from '../helpers/qRules.node.helpers';
import { toXml } from '../helpers/jsonXmlConvert';

const description =
    'Converts a JSON string to XML and places the converted XML into one of the form’s data sources.';

const requiredParameters = [
    {
        name: paramXPath,
        description:
            'XPath of the location where the converted JSON should be inserted',
        type: typeXPath,
        dsParentName: paramDsName,
    },
    {
        name: paramJson,
        description:
            'JSON to convert into XML. Tip: Use /json-xpath (and optionally /json-dsname) to get the JSON from a field in the form.',
    },
];
const optionalParameters = [
    {
        name: paramDsName,
        description:
            'Name of the data source where the converted JSON should be inserted',
        type: typeDataSource,
    },
];

function deleteChildNodes(node) {
    node.childNodes().forEach((n) => {
        n.deleteSelf();
    });
}

async function appendNodesAsync(dest, nodes) {
    for (const node of nodes) {
        await dest.appendChildAsync(node);
    }
}

const parseJsonOrFail = (json) => {
    try {
        return JSON.parse(json);
    } catch (e) {
        throw new Error('Invalid JSON: ' + json);
    }
};

async function executeAsync({ dataSources, parameters }) {
    const xpath = getParamValue(parameters, paramXPath);
    const json = getParamValue(parameters, paramJson);
    const dsname = getParamValue(parameters, paramDsName);
    const ds = getDataSource(dataSources, dsname);
    const destNode = getValidNode(ds, xpath);
    const destNodeRaw = destNode.getNode();
    const jsObj = parseJsonOrFail(json);

    if (!isElement(destNodeRaw)) {
        throw new Error('Destination node must be an element.');
    }

    const xml = toXml(jsObj);
    const type = xml.getAttribute('type');

    deleteChildNodes(destNode);

    destNodeRaw.setAttribute('type', type);

    await appendNodesAsync(destNode, allChildNodes(xml));

    return '';
}

const JsonToXml = {
    description,
    requiredParameters,
    optionalParameters,
    executeAsync,
};

export default JsonToXml;
